import React from "react";
import "./Industries.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import feature1 from "./../images/fea1.svg";
import feature2 from "./../images/fea2.svg";
import feature3 from "./../images/fea3.svg";
import feature4 from "./../images/fea4.svg";
import feature5 from "./../images/fea5.svg";
import feature6 from "./../images/fea6.svg";
import feature7 from "./../images/fea7.svg";
import feature8 from "./../images/fea8.svg";

const Industriesslider = () => {
  var settings = {
    dots: false,
    infinite: true,
    center: true,
    autoplay:true,
    loop: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="industry-slider">
      <div>
        <div className="industy-carousel center">
          
            <div className="row">
            <Slider {...settings}>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature1} alt="feature" />
                </div>
                <h5>Fertilizers  </h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature2} alt="feature" />
                </div>
                <h5>Automotive</h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature3} alt="feature" />
                </div>
                <h5>Engineering & Manufacturing</h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature4} alt="feature" />
                </div>
                <h5>Pharmaceuticals</h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature5} alt="feature" />
                </div>
                <h5>Construction </h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature6} alt="feature" />
                </div>
                <h5>Distribution</h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature7} alt="feature" />
                </div>
                <h5>Electrical & Electronics </h5>
              </div>
              <div className="col-md-3">
                <div className="industy-img">
                  <img src={feature8} alt="feature" />
                </div>
                <h5>Paints & chemicals </h5>
              </div>
           
              </Slider>
            </div>
         
        </div>
      </div>
    </div>
  );
};

export default Industriesslider;
